import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  // A Turbo stream can replace the modal while it's open, which skips close()
  // and would otherwise leave the page permanently unscrollable.
  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    event.preventDefault()
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    if (event.target === this.modalTarget || event.target.closest("[data-close]")) {
      this.modalTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.modalTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }
  }
}
